module.exports = __webpack_public_path__ + "media/Video 100.0228e757.mp4";